import React, { useEffect, useState } from "react";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import {
  Box,
  Button,
  Container,
  CssBaseline,
  Grid,
  IconButton,
  ImageList,
  ImageListItem,
  InputAdornment,
  Link,
  TextField,
  AppBar,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { postAPI } from "../../services/basehttpAPI";
import SnackbarComponent from "../../components/snackbar";
import { useNavigate } from "react-router-dom";
import Copyright from "../../components/copyright";

const theme = createTheme();

const ResetPassword = () => {
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [newPassword, setNewPassword] = useState(null);
  const [confirmPassword, setConfirmPassword] = useState(null);
  const [validNewPassword, setValidNewPassword] = useState(true);
  const [validConfirmPassword, setValidConfirmPassword] = useState(true);
  const [open, setOpen] = useState(false);
  const [message, setmessage] = useState(null);
  const [severity, setseverity] = useState(null);
  const [authmodel, setauthmodel] = useState({
    username: null,
    password: null,
  });
  const [errornewpasswordtext, setnewerrorpasswordtext] = useState(null);
  const [errorconfirmpasswordtext, setconfirmerrorpasswordtext] =
    useState(null);
    const translatedText = JSON.parse(sessionStorage.getItem("TranslationText"));
  let search = window.location.search;
  let params = new URLSearchParams(search);
  const navigate = useNavigate();
  const tokenModel = {
    token: params.get("token"),
  };
  console.log("t", tokenModel);
  const handleClickShowNewPassword = () => setShowNewPassword((show) => !show);
  const handleClickShowConfirmPassword = () =>
    setShowConfirmPassword((show) => !show);

  useEffect(() => {
      setnewerrorpasswordtext(
          validNewPassword ? null : "La contraseña debe tener al menos 10 caracteres e incluir una mayúscula, una minúscula, un número y un carácter especial."/*translatedText.please_enter_valid_password*/
    );
    setconfirmerrorpasswordtext(
        validConfirmPassword ? null : "La contraseña debe tener al menos 10 caracteres e incluir una mayúscula, una minúscula, un número y un carácter especial."/*translatedText.please_enter_valid_password*/
    );
  }, [validNewPassword, validConfirmPassword]);

  const verifyForgotPasswordToken = async () => {
    let url = `Authentication/VerifyForgotPasswordToken?token=${encodeURIComponent(tokenModel.token)}`;
    const response = await postAPI(url, null);
    const data = response.data.responseData;
    if (data) {
      const decodetoken = JSON.parse(
        window.atob(tokenModel.token.split(".")[1])
      );
      setauthmodel({
        ...authmodel,
        username: decodetoken.email,
      });
    } else {
      tokenExpired();
    }
  };

  useEffect(() => {
    verifyForgotPasswordToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleClose = () => {
    setOpen(false);
  };

  function handleNewPasswordChange(evt) {
    const value = evt.target.value;
    setNewPassword(value);
  }

  function handleConfirmPasswordChange(evt) {
    const value = evt.target.value;
    setConfirmPassword(value);
  }

  const handleVaild = (e) => {
    const value = e.target.value;
    if (e.target.value.trim() !== "") {
      if (e.target.name === "newPassword") {
        const reg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[^0-9a-zA-Z]).{10,}$");
        let isValidPassword = reg.test(value); //value.match(reg);
        if (isValidPassword) {
          setValidNewPassword(true);
        } else {
          setValidNewPassword(false);
        }
      } else if (e.target.name === "confirmPassword") {
        const reg = new RegExp("^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*[^0-9a-zA-Z]).{10,}$");
        let isValidPassword = reg.test(value);
        if (isValidPassword) {
          setValidConfirmPassword(true);
          setauthmodel({
            ...authmodel,
            password: value,
          });
        } else {
          setValidConfirmPassword(false);
        }
      }
    } else {
      if (e.target.name === "newPassword") {
        setValidNewPassword(false);
      }
      if (e.target.name === "confirmPassword") {
        setValidConfirmPassword(false);
      }
    }
  };

  function checkPasswordMatch() {
    if (
      newPassword !== null &&
      confirmPassword !== null &&
      validNewPassword &&
      validConfirmPassword
    ) {
      if (newPassword === confirmPassword) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }

  function tokenExpired() {
      setseverity("error");
      setmessage("Elemento caducado .. ¡¡Por favor, inténtelo de nuevo!!"/*translatedText.token_expired_please_try_again*/);
    setOpen(true);
    //navigate("/login");
  }

  const handleSubmit = async (event) => {
    event.preventDefault();
    const isNewPasswordEmpty = !newPassword || newPassword.trim() === "";
    const isConfirmPasswordEmpty = !confirmPassword || confirmPassword.trim() === "";

    if (isNewPasswordEmpty) {
      setValidNewPassword(false);
    }

    if (isConfirmPasswordEmpty) {
      setValidConfirmPassword(false);
    }
    if (isNewPasswordEmpty || isConfirmPasswordEmpty) {
      return;
    }

    if (!validNewPassword || !validConfirmPassword) {
      return;
    }
    
    const passwordMatch = checkPasswordMatch();

    if (!passwordMatch) {
      setseverity("error");
      setmessage("Password mismatch"/*translatedText.password_mismatch*/);
      setOpen(true);
      return;
    }
    if (
      authmodel.username != null &&
      authmodel.password != null 
    ) {
      const payload = {
        ...authmodel,
        token: tokenModel.token,
      }

      let url = "authentication/resetPassword";
      const response  = await postAPI(url, payload);
      const data = response?.data;
      if (data) {
        if (data.isSuccess) {
            setseverity("success");
            setmessage("Tu contraseña ha sido modificada"/*translatedText.your_password_has_been_successfully_changed*/);
          setOpen(true);
          navigate("/login");
        } else if (!data.isSuccess) {
          setseverity("error");
          setmessage(data.errorMessages);
          setOpen(true);
        } else {
            setseverity("error");
            setmessage("Algo salió mal. ¡Por favor, inténtalo de nuevo ¡"/*translatedText.something_went_wrong_please_try_again_sometime*/);
            setOpen(true);
        }
      } else  {
          setseverity("error");
          setmessage("Algo salió mal. ¡Por favor, inténtalo de nuevo ¡"/*translatedText.something_went_wrong_please_try_again_sometime*/);
          setOpen(true);
      }
    } else {
      if (!passwordMatch) {
          setseverity("error");
          setmessage("Password mismatch"/*translatedText.password_mismatch*/);
          setOpen(true);
      }
      if (authmodel.password === null) {
        setValidNewPassword(false);
        setValidConfirmPassword(false);
      }
    }
  };

  return (
    <ThemeProvider theme={theme}>
      <Container component="main" maxWidth="lg" sx={{ mt: 0, mb: 0, ml: 0 }}>
        <CssBaseline />
        <Grid container spacing={3}>
          <Grid
            item
            xs={12}
            sm={4}
            md={4}
            lg={3}
            sx={{
              backgroundColor: "#D8DDE0CC",
              height: { sm: "100%", md: "100%", lg: "103vh" },
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            <ImageList>
              <ImageListItem>
                <img
                  src={process.env.PUBLIC_URL + "/images/box.png"}
                  alt="box"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/deliveryvan.png"}
                  alt="van"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/globe.png"}
                  alt="globe"
                  className="Loginlogo"
                />
                <img
                  src={process.env.PUBLIC_URL + "/images/filelock.png"}
                  alt="filelock"
                  className="Loginlogo"
                />
              </ImageListItem>
            </ImageList>
          </Grid>
          <Grid item xs={0}></Grid>
          <Grid item xs={12} sm={7} md={6} lg={5}>
            <img
              src={process.env.PUBLIC_URL + "/images/albaraneslogo.png"}
              alt="logo"
              height="120"
            />
            <Box
              sx={{
                marginTop: "15%",
                display: "flex",
                flexDirection: "column",
              }}
            >
                          <Typography component="h1" variant="h5">
                              {/*translatedText.forgot_password*/ "¿Olividaste la contraseña?"}/ {"Restablecer contraseña"/*translatedText.reset_password*/}
              </Typography>
            </Box>
            {authmodel.username ? (
              <Box
                component="form"
                onSubmit={handleSubmit}
                noValidate
                sx={{ mt: 3 }}
              >
                <Typography>
                                  {"Correo Electronico"/*translatedText.email_id*/}: <b>{authmodel.username}</b>
                </Typography>
                <TextField
                  margin="normal"
                  fullWidth
                  name="newPassword"
                                  label="Nueva contraseña"
                  type={showNewPassword ? "text" : "password"}
                  id="newPassword"
                  required={true}
                  autoComplete="off"
                  onChange={handleNewPasswordChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowNewPassword}
                          edge="end"
                        >
                          {showNewPassword ? <Visibility /> : <VisibilityOff />}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onBlur={handleVaild}
                  error={errornewpasswordtext !== null ? true : false}
                  helperText={errornewpasswordtext}
                />
                <TextField
                  margin="normal"
                  fullWidth
                  name="confirmPassword"
                                  label="Confirmar contraseña"
                  type={showConfirmPassword ? "text" : "password"}
                  id="confirmPassword"
                  required={true}
                  autoComplete="off"
                  onChange={handleConfirmPasswordChange}
                  InputProps={{
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={handleClickShowConfirmPassword}
                          edge="end"
                        >
                          {showConfirmPassword ? (
                            <Visibility />
                          ) : (
                            <VisibilityOff />
                          )}
                        </IconButton>
                      </InputAdornment>
                    ),
                  }}
                  onBlur={handleVaild}
                  error={errorconfirmpasswordtext !== null ? true : false}
                  helperText={errorconfirmpasswordtext}
                />
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="success"
                  sx={{ mt: 3, mb: 2 }}
                >
                    {" "}
                                  {"Restablecer contraseña"/*translatedText.reset_password*/}
                </Button>
              </Box>
            ) : (
              <Grid container>
                {/* <Grid item xs></Grid> */}
                <Grid item style={{ marginTop: 5 }}>
                  <Link
                    href={process.env.PUBLIC_URL + "/login"}
                    variant="body2"
                    underline="hover"
                    >
                                          {"¿Desea iniciar sesión?"/*translatedText.do_you_want_to_login*/}
                  </Link>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </Container>
      <AppBar
        position="fixed"
        sx={{
          top: "auto",
          bottom: 0,
          backgroundColor: "white",
          zIndex: "0",
          boxShadow: "0",
          width: { xs: "100%", sm: "90%", md: "62%", lg: "75%", xl: "80%" },
        }}
      >
        <Copyright align="left" />
      </AppBar>
      <SnackbarComponent
        open={open}
        handleClose={handleClose}
        message={message}
        severity={severity}
      />
    </ThemeProvider>
  );
};

export default ResetPassword;
